import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { Col, Row } from "react-bootstrap";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { useDispatch } from "react-redux";

const InvoicesList = () => {
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState(1);

  // const onChangeSearch = (event: any) => {
  //   setSearchValue(event.target.value);
  // };
    useEffect(() => {
      const data = {
        first: "Invoices",
      };
      dispatch(Change(data));
    }, []);
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox value={searchValue} />
        </Col>
      </Row>

      <div className="row mt-4">
        <div className="col-12">
          <DashTable />
        </div>
        <Pagination setPagination={setPagination} pagination={pagination} />
      </div>
    </div>
  );
};

export default InvoicesList;
